export default __webpack_public_path__ + "static/media/tomato.936d0597.png";